// Premises and Resources checklist. Each item gets its own page under
// /tvec/premises/<slug>; those pages are built one at a time later.
const TITLES = [
  'Classroom space (Capacity)',
  'Lab Facilities for Practical (Capacity)',
  'Industrial Agreement for Practical',
  'Electricity',
  'Light (All must work)',
  'Ventilation – Windows /Air-conditioned',
  'Sanitary Facilities – Toilets and water Taps',
  'Cleaning Charts',
  'First Aid Facilities',
  'First Aid Training for staffs',
  'Fire Safety Measures / Fire Extinguishers (Check the expiry dates and renew them)',
  'Fire Training',
  'Fire Drills',
  'Fire Exits and Fire Assembly',
  'Computers -Condition and Service Agreements',
  'Tools for Trainings – According to the Programs',
  'Equipment for Trainings (Multimedia)',
];

const slugify = (text) => text.toLowerCase().replace(/\(.*?\)/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

export const PREMISES_PATH = '/tvec/premises';

export const PREMISES_ITEMS = TITLES.map((title, i) => ({
  number: i + 1,
  title,
  slug: slugify(title),
  path: `${PREMISES_PATH}/${slugify(title)}`,
}));

export const findPremisesItem = (slug) => PREMISES_ITEMS.find((item) => item.slug === slug) || null;
